<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Riapertura Master </v-toolbar-title>
      <v-spacer></v-spacer>

      <span>
        <v-btn
          @click="clickConfermaCompensazione"
          class="mr-10"
          small
          v-if="modalita == 'magazzino' && prelievo != null"
        >
          <v-icon color="success">mdi-floppy</v-icon>
        </v-btn>
      </span>

      <span>
        <v-btn
          @click="clickConfermaRiapertura"
          class="mr-10"
          small
          v-if="modalita == 'produzione'"
        >
          <v-icon color="success">mdi-floppy</v-icon>
        </v-btn>
      </span>

      <DataMatrixReader
        ref="qr"
        v-on:detectQrCode="detectQrCode"
        @clickChiudi="resetModalita"
        v-if="modalita == 'magazzino' || modalita == 'produzione'"
      />
      <v-spacer></v-spacer>
      <!-- Bottone di chiusura del componente -->
      <v-tooltip bottom v-if="modalita == ''">
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>

      <!-- Bottone di annullamento foto dei seriali -->
      <v-tooltip
        bottom
        v-else-if="modalita == 'magazzino' || modalita == 'produzione'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="resetModalita" small v-bind="attrs" v-on="on">
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <!-- Form di selezione della modalità -->
      <v-container class="mt-5" fluid v-if="modalita == ''">
        <v-row dense>
          <v-col cols="6">
            <span style="color: black; font-size: 20px">
              Compensazione dal Magazzino
            </span>
          </v-col>
          <v-col cols="6">
            <span style="color: black; font-size: 20px">
              Compensazione dalla Produzione
            </span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
            <v-btn
              class="mt-5"
              @click="enterMagazzinoMode"
              width="150px"
              height="150px"
            >
              <v-icon color="primary" size="125px"> mdi-warehouse </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              class="mt-5"
              @click="enterProduzioneMode"
              width="150px"
              height="150px"
            >
              <v-icon color="primary" size="125px">
                mdi-cog-transfer-outline
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container class="mt-5" v-else-if="modalita == 'magazzino'">
        <v-row dense>
          <v-col cols="12">
            <v-row dense align="center" justify="center">
              <v-col cols="7" align="start">
                <span style="font-size: 17px">
                  Seriale di prelievo:
                  <b>{{
                    prelievo == null
                      ? " (Attivare fotocamera)"
                      : prelievo.seriale
                  }}</b>
                </span>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  dense
                  hide-details
                  label="Prelievo"
                  outlined
                  style="border-radius: 0px"
                  type="number"
                  v-if="prelievo != null"
                  v-model.number="prelievo.quantita"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  dense
                  hide-details
                  label="Scarto"
                  outlined
                  style="border-radius: 0px"
                  type="number"
                  v-if="prelievo != null"
                  v-model.number="prelievo.quantita_scarto"
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-tooltip bottom v-if="prelievo != null">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="dettaglioScarto(prelievo)"
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon :color="getColorPennaScarti(prelievo)">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Dettaglio Scarti</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-row
              v-if="versamenti.length > 0"
              align="center"
              dense
              justify="center"
            >
              <v-col cols="12">
                <v-divider class="my-5"></v-divider>
              </v-col>
            </v-row>

            <!-- Versamenti se non ho ancora preso il primo versamento. -->
            <span v-if="prelievo != null && versamenti.length == 0">
              <v-row dense>
                <v-col cols="12">
                  <div
                    style="
                      border: 1px solid black;
                      display: inline-block;
                      margin-top: 20px;
                      padding: 12px;
                    "
                  >
                    <span style="color: black; font-size: 16px">
                      Attivare la fotocamera e inquadrare i codici QR<br />
                      per aggiungere contenitori di versamento.
                    </span>
                  </div>
                </v-col>
              </v-row>
            </span>

            <!-- Versamenti se ho già preso il primo versamento. -->
            <span v-else-if="prelievo != null">
              <v-row
                align="center"
                dense
                justify="center"
                :key="i"
                v-for="(versamento, i) in versamenti"
              >
                <v-col align="start" cols="9">
                  <span style="font-size: 17px">
                    Seriale di versamento:
                    <b>{{ versamento.seriale }}</b>
                  </span>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    dense
                    hide-details
                    label="Scarto"
                    outlined
                    style="border-radius: 0px"
                    type="number"
                    v-model.number="versamento.quantita"
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="dettaglioScarto(versamento)"
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon :color="getColorPennaScarti(versamento)">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Dettaglio Scarti</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </span>
          </v-col>
        </v-row>
      </v-container>
      <v-container class="mt-5" fluid v-else-if="modalita == 'produzione'">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-row dense align="center" justify="center">
              <v-col cols="9" align="start">
                <span style="font-size: 17px">
                  Master da riaprire:
                  <b>{{
                    prelievo == null
                      ? " (Attivare la fotocamera per selezionare)"
                      : prelievo.seriale
                  }}</b>
                </span>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  dense
                  hide-details
                  label="Slave"
                  outlined
                  style="border-radius: 0px"
                  type="number"
                  v-model.number="qta_slave"
                  v-if="prelievo != null"
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <v-btn
                  @click="stampaSeriali"
                  color="primary"
                  icon
                  v-if="prelievo != null"
                >
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog di conferma compensazione -->
    <v-dialog v-model="conferma_quantita_dialog" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eseguire la compensazione?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_quantita_dialog = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="confermaQuantita" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Overlay di caricamento -->
      <v-overlay :value="caricamento_dati" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Dialog di conferma riapertura -->
    <v-dialog v-model="conferma_riapertura_dialog" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Conferma </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eseguire la riapertura di questo master?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_riapertura_dialog = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="confermaRiapertura" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Overlay di caricamento -->
      <v-overlay :value="caricamento_dati" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Mini dialog per indicare gli impegni delle macchine -->
    <v-dialog v-model="dialog_impegni" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Impegni </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              dialog_impegni = false;
              conferma_dialog = false;
            "
            small
          >
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-3">
          <div style="display: inline-block; max-width: 500px">
            <span style="font-size: 15px">
              Questo master non è disponibile per il carrello delle lavorazioni
              perché risulta già aperto per questo operatore:
            </span>
          </div>
          <v-data-table
            :headers="headers_macchine_impegnate"
            hide-default-footer
            :items="items_macchine_impegnate"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di visualizzazione etichette -->
    <v-dialog persistent v-model="dialog_risme_etichette" width="600">
      <v-card>
        <!-- Toolbar del dialog -->
        <v-toolbar dense color="indigo">
          <v-toolbar-title class="white--text">
            Etichette Generate
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_risme_etichette = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-row align="center" justify="center">
            <v-col cols="4" v-for="(elem, i) in items_risme_etichette" :key="i">
              <!-- Sezione della miniatura + cod_report -->
              <div>
                <!-- Sezione della miniatura -->
                <div>
                  <v-icon
                    @click="showPdfViewer(elem)"
                    color="error"
                    x-large
                    style="font-size: 100px"
                  >
                    mdi-file-pdf-box
                  </v-icon>
                </div>
                <!-- Sezione del cod_report -->
                <div>
                  <span>
                    <b>{{ elem.des }}</b>
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di visualizzazione etichette -->
    <v-dialog v-model="dialog_preview" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Stampa Etichetta
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogPreview"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-col cols="12">
          <iframe
            :src="iframeUrl"
            frameborder="0"
            style="height: 70vh !important; width: 750px !important"
          >
          </iframe>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialog_scarti" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Causali di Scarto
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio degli scarti -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaScarti" small v-bind="attrs" v-on="on">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura del dielog degli scarti -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_scarti = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row
              align="center"
              justify="center"
              :key="causale.id_causale"
              v-for="causale in items_causali_sel"
            >
              <v-col cols="8" align="right" class="px-5">
                <span style="color: black; font-size: 18px">
                  <b>{{ causale.des }}</b>
                </span>
              </v-col>
              <v-col cols="4" align="left" class="px-5">
                <v-text-field
                  background-color="#ffffff"
                  dense
                  hide-details
                  label=""
                  outlined
                  style="
                    border-radius: 0px;
                    display: inline-block;
                    font-size: 20px;
                    max-width: 100px;
                  "
                  type="number"
                  v-model.number="causale.pezzi"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Snackbar del dialog di dettaglio scarti -->
      <SnackbarQV ref="SnackbarQVScarti" />
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import DataMatrixReader from "@/components/TOOLS/DataMatrixReader.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Scarto {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "des", default_val: "" },
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_movimenti", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "id_personale", default_val: null },
      { nome: "pezzi", default_val: 0 },
      { nome: "seriale", default_val: null },
      { nome: "tipo_causale", default_val: "SCARTO" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "",
  components: {
    DataMatrixReader,
    SnackbarQV,
  },
  props: {
    work_order: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      iframeUrl: null,
      modalita: "",
      prelievo: null,
      qta_slave: 0,
      seriale_sel: null,

      // Modal
      caricamento_dati: false,
      conferma_quantita_dialog: false,
      conferma_riapertura_dialog: false,
      dialog_impegni: false,
      dialog_preview: false,
      dialog_risme_etichette: false,
      dialog_scarti: false,

      // Array
      headers_macchine_impegnate: [
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Utente",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Ora Start",
          sortable: false,
          value: "data_inizio",
        },
      ],
      items_causali: new Array(),
      items_causali_sel: new Array(),
      items_macchine_impegnate: new Array(),
      items_risme_etichette: new Array(),
      versamenti: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    chiudiDialogPreview() {
      this.dialog_preview = false;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickConfermaCompensazione() {
      /* Controllo che tutti gli scarti siano a posto; la funzione
       * che restituisce il colore della penna degli scarti mi dice
       * "orange" se gli scarti non sono a posto, "primary" se sono
       * conformi. Uso questa funzione per capire se sul seriale di
       * prelievo e su quelli di versamento l'utente ha fatto tutto
       * quello che deve. */
      let chk_qta_scarti_ok = true;
      if (this.getColorPennaScarti(this.prelievo) == "orange") {
        chk_qta_scarti_ok = false;
      }

      this.versamenti.forEach((v) => {
        if (this.getColorPennaScarti(v) == "orange") {
          chk_qta_scarti_ok = false;
        }
      });

      if (!chk_qta_scarti_ok) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Per alcuni seriali la quantità di scarto non corrisponde alle quantità delle causali dichiarate."
        );
        return;
      }

      // Controllo che le quantità siano corrette.
      if (this.prelievo.quantita < 0 || this.prelievo.quantita === null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Valorizzare la quantità del seriale di prelievo almeno a 0."
        );
        return;
      }

      // Controllo che le quantità siano corrette.
      if (
        (this.prelievo.quantita <= 0 || this.prelievo.quantita === null) &&
        this.versamenti.length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Valorizzare positivamente la quantità del seriale di prelievo."
        );
        return;
      }

      let chk_qta_versamenti = true;
      this.versamenti.forEach((v) => {
        if (v.quantita === null || v.quantita <= 0) {
          chk_qta_versamenti = false;
        }
      });

      if (chk_qta_versamenti === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Valorizzare positivamente la quantità di tutti i seriali di versamento."
        );
        return;
      }

      let qta_totale = 0;
      this.versamenti.forEach((v) => {
        qta_totale += v.quantita;
      });

      if (qta_totale != this.prelievo.quantita) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il totale dei versamenti deve essere uguale alla quantità di prelievo."
        );
        return;
      }

      this.conferma_quantita_dialog = true;
    },
    clickConfermaRiapertura() {
      if (this.prelievo == null) {
        this.$refs.SnackbarQV.print("orange", "Selezionare un master.");
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "chkriaperturamaster",
          token: localStorage.user_token,
          master: this.prelievo.seriale,
          id_commessa_dettaglio: this.work_order.id_commessa_dettaglio,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            if (res.data.response == "OK") {
              this.conferma_riapertura_dialog = true;
            } else if (res.data.response == "carrello impegnato") {
              this.$refs.SnackbarQV.print(
                "orange",
                `Il master ${res.data.message} deve ancora essere chiuso in questo carrello.`
              );
            } else if (res.data.response == "master in corso") {
              this.items_macchine_impegnate = res.data.result;
              this.dialog_impegni = true;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile verificare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    confermaQuantita() {
      // Array per salvare le causali in commessa_movimenti.
      const causali_tmp = new Array();

      // Array per salvare gli scarti del prelievo in magazzino_movimenti.
      const causali_prelievo_tmp = new Array();

      // Array per salvare gli scarti del versamento in magazzino_movimenti.
      const causali_versamento_tmp = new Array();

      this.prelievo.causali.forEach((c) => {
        if (c.pezzi > 0) {
          causali_tmp.push(JSON.parse(JSON.stringify(c)));
          causali_prelievo_tmp.push({
            id_magazzino_movimenti: -1,
            id_articolo: this.work_order.id_articolo,
            id_causale: c.id_causale,
            cod_articolo: this.work_order.cod_articolo,
            des_articolo: this.work_order.des_articolo,
            id_um: this.work_order.id_um,
            quantita: c.pezzi,
            id_commessa: this.work_order.id_commessa,
            id_commessa_dettaglio: this.work_order.id_commessa_dettaglio,
            numero_seriale: this.prelievo.seriale,
            seriale: this.prelievo.seriale,
            flag_export: 0,
          });
        }
      });
      delete this.prelievo.causali;

      this.versamenti.forEach((v) => {
        v.causali.forEach((c) => {
          if (c.pezzi > 0) {
            causali_tmp.push(JSON.parse(JSON.stringify(c)));
            causali_versamento_tmp.push({
              id_magazzino_movimenti: -1,
              id_articolo: this.work_order.id_articolo,
              id_causale: c.id_causale,
              cod_articolo: this.work_order.cod_articolo,
              des_articolo: this.work_order.des_articolo,
              id_um: this.work_order.id_um,
              quantita: c.pezzi,
              id_commessa: this.work_order.id_commessa,
              id_commessa_dettaglio: this.work_order.id_commessa_dettaglio,
              numero_seriale: v.seriale,
              seriale: v.seriale,
              flag_export: 0,
            });
          }
        });

        delete v.causali;
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "compensazionemaster",
          token: localStorage.user_token,
          prelievo: [this.prelievo],
          versamenti: this.versamenti,
          modalita: this.modalita,
          causali: causali_tmp,
          causali_prelievo: causali_prelievo_tmp,
          causali_versamento: causali_versamento_tmp,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200 && res.data.response == true) {
            this.conferma_quantita_dialog = false;
            this.$refs.SnackbarQV.print("success", "Compensazione eseguita.");
            this.$emit("riaperto_master");
            this.resetModalita();
          } else {
            this.$refs.SnackbarQV.print("orange", res.data.response);
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    confermaRiapertura() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "riaperturamaster",
          token: localStorage.user_token,
          master: this.prelievo.seriale,
          id_commessa: this.work_order.id_commessa,
          id_commessa_dettaglio: this.work_order.id_commessa_dettaglio,
          id_commessa_tempi: this.work_order.id_commessa_tempi,
          id_macchina: this.work_order.id_macchina,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200 && res.data.response == true) {
            this.$emit("riapertura_master", this.prelievo.seriale);
            this.resetModalita();
          } else {
            this.$refs.SnackbarQV.print("orange", res.data.response);
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    detectQrCode(arg) {
      console.log(arg);
      if (
        !arg.includes("(P)") ||
        !arg.includes("(S)") ||
        !arg.includes("GETQRC")
      ) {
        this.$refs.SnackbarQV.print("orange", "Codice a matrice non conforme.");
        return;
      }

      // Ricavo seriale e codice articolo.
      const articolo_tmp = arg.split("(P)")[1].split(";")[0];
      const seriale_tmp = arg.split("(S)")[1].split(";")[0];
      const cod_packaging_tmp = arg.split("(K)")[1].split(";")[0];

      // Controllo che sia l'articolo giusto.
      if (articolo_tmp != this.work_order.cod_articolo) {
        this.$refs.SnackbarQV.print(
          "orange",
          "L'articolo non corrisponde a quello attualmente in lavorazione."
        );
        return;
      }

      // Controllo che il seriale non sia già presente.
      if (
        this.versamenti.filter((v) => v.seriale == seriale_tmp).length > 0 ||
        (this.prelievo != null && seriale_tmp == this.prelievo.seriale)
      ) {
        this.$refs.SnackbarQV.print("orange", "Il seriale è già presente.");
        return;
      }

      if (this.prelievo == null) {
        this.prelievo = {
          seriale: seriale_tmp,
          quantita: 0,
          quantita_scarto: 0,
          cod_packaging: cod_packaging_tmp,
        };

        this.prelievo.causali = JSON.parse(JSON.stringify(this.items_causali));

        this.prelievo.causali.forEach((c) => {
          c.seriale = this.prelievo.seriale;
        });

        this.$refs.SnackbarQV.print(
          "success",
          this.modalita == "magazzino"
            ? "Etichetta di prelievo acquisita. Presentare le etichette di versamento."
            : "Etichetta acquisita"
        );
      } else {
        const versamento_tmp = {
          seriale: seriale_tmp,
          quantita: 0,
        };
        versamento_tmp.causali = JSON.parse(JSON.stringify(this.items_causali));
        versamento_tmp.causali.forEach((c) => {
          c.seriale = versamento_tmp.seriale;
        });

        this.versamenti.push(versamento_tmp);
        this.$refs.SnackbarQV.print(
          "success",
          "Etichetta di versamento acquisita acquisita."
        );
      }
    },
    dettaglioScarto(arg) {
      /* Se non ho ancora indicato scarti è inutile che apra
       * il dettaglio: prima devo indicare la quantità degli
       * scarti, poi devo aprire il dettaglio per ripartirli. */
      if (arg.quantita_scarto != undefined) {
        if (arg.quantita_scarto == 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Indicare la quantità degli scarti prima di ripartire le causali."
          );
          return;
        }
      } else {
        if (arg.quantita == 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Indicare la quantità degli scarti prima di ripartire le causali."
          );
          return;
        }
      }

      this.seriale_sel = arg.seriale;
      this.items_causali_sel = new Array();

      /* Se sto guardando il dettaglio del prelievo,
       * prendo le sue causali di scarto. */
      if (this.prelievo.seriale == this.seriale_sel) {
        this.prelievo.causali.forEach((c) => {
          this.items_causali_sel.push(new Scarto(c));
        });
      } else {
        /* Se sto guardando un versamento, cernisco i versamenti
         * fino a trovare quello che mi interessa e renderizzo
         * delle copie di modifica delle sue causali di scarto. */
        this.versamenti.forEach((v) => {
          if (v.seriale == this.seriale_sel) {
            v.causali.forEach((c) => {
              this.items_causali_sel.push(new Scarto(c));
            });
          }
        });
      }
      this.dialog_scarti = true;
    },
    enterMagazzinoMode() {
      this.prelievo = null;
      this.versamenti = new Array();
      this.modalita = "magazzino";
      this.getCausaliScarto();
    },
    enterProduzioneMode() {
      this.modalita = "produzione";
    },
    getCausaliScarto() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.user_token,
          tipo: "PRODUZIONE_CAUSALI",
          filter:
            "(val_int IS NULL OR val_int = " +
            this.work_order.id_fase +
            ") AND validita = 1",
        },
      };

      /* Se l'array "matrice" delle causali è già popolato,
       * non faccio la chiamata perché sarebbe inutile. */
      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.items_causali = new Array();
            if (res.data) {
              res.data.forEach((e) => {
                this.items_causali.push(
                  new Scarto({
                    des: e.des,
                    id_causale: e.id_tabella,
                    id_commessa: this.work_order.id_commessa,
                    id_commessa_dettaglio:
                      this.work_order.id_commessa_dettaglio,
                    id_commessa_tempi: this.work_order.id_commessa_tempi,
                    id_personale: localStorage.id,
                  })
                );
              });
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          this.caricamento_dati = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          return false;
        });
    },
    getColorPennaScarti(arg) {
      /* Se ho già dichiarato correttamente i pezzi di scarto
       * ritorno colore azzurro, altrimenti arancione. */
      let sommatoria = 0;
      arg.causali.forEach((c) => {
        sommatoria += c.pezzi == null ? 0 : c.pezzi;
      });

      if (arg.quantita_scarto != undefined) {
        return sommatoria == arg.quantita_scarto ? "primary" : "orange";
      } else {
        return sommatoria == arg.quantita ? "primary" : "orange";
      }
    },
    resetModalita() {
      (this.dialog_scarti = false), (this.modalita = "");
      this.prelievo = null;
      this.versamenti = new Array();
      this.qta_slave = 0;
      this.seriale_sel = null;
      this.items_causali = new Array();
      this.items_causali_sel = new Array();
      this.items_macchine_impegnate = new Array();
    },
    salvaScarti() {
      // Mi metto da parte la sommatoria delle quantità per i controlli successivi.
      let sommatoria = 0;
      this.items_causali_sel.forEach((c) => {
        sommatoria += c.pezzi == null ? 0 : c.pezzi;
      });

      /* Se sto guardando il dettaglio del prelievo,
       * gli salvo sopra le causali provvisorie. */
      if (this.prelievo.seriale == this.seriale_sel) {
        // Prima di salvare controllo la coerenza delle quantità.
        if (this.prelievo.quantita_scarto != sommatoria) {
          this.$refs.SnackbarQVScarti.print(
            "orange",
            `Sono inputati ${sommatoria} scarti a fronte di ${this.prelievo.quantita_scarto} previsti.`
          );
          return;
        }

        // Se le quantità sono coerenti, salvo.
        this.prelievo.causali = new Array();
        this.items_causali_sel.forEach((c) => {
          this.prelievo.causali.push(new Scarto(c));
        });

        // Se è andato tutto bene, chiudo il dialog.
        this.dialog_scarti = false;
      } else {
        /* Se sto guardando un versamento, cernisco i versamenti
         * fino a trovare quello che mi interessa e gli salvo
         * sopra le causali attualmente visualizzate. */
        this.versamenti.forEach((v) => {
          if (v.seriale == this.seriale_sel) {
            // Prima di salvare controllo la coerenza delle quantità.
            if (v.quantita != sommatoria) {
              this.$refs.SnackbarQVScarti.print(
                "orange",
                `Sono inputati ${sommatoria} scarti a fronte di ${v.quantita} previsti.`
              );
              return;
            }

            // Se le quantità sono coerenti, salvo.
            v.causali = new Array();
            this.items_causali_sel.forEach((c) => {
              v.causali.push(new Scarto(c));
            });
          }
        });

        // Se è andato tutto bene, chiudo il dialog.
        this.dialog_scarti = false;
      }
    },
    showPdfViewer(arg) {
      this.iframeUrl = arg.base64;
      this.dialog_preview = true;
    },
    stampaSeriali() {
      if (
        this.qta_slave <= 0 ||
        this.qta_slave == null ||
        this.qta_slave == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare una quantità di slave non nulla."
        );
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getserialeriaperturamaster",
          token: localStorage.user_token,
          id_articolo: this.work_order.id_articolo,
          cod_packaging: this.prelievo.cod_packaging,
          qta_slave: this.qta_slave,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            // Se il BE ha rilevato un problema, lo stampo e mi fermo.
            if (res.data.statusCode == 400) {
              this.$refs.SnackbarQV.print("orange", res.data.response);
              return;
            }

            // Se non ci sono problemi, procedo con la chiamata successiva.
            let jres = JSON.parse(res.data.result);
            jres = jres[0];

            const request2 = {
              controller: "Magazzino",
              method: "PUT",
              richiesta: {
                action: "registraestampa",
                token: localStorage.user_token,
                nome_parametro_seriale: "@id_articolo",
                dati_report: {
                  cod_report: jres.cod_report,
                  parametri: [
                    {
                      parametro: "@id_articolo_packaging",
                      valore: jres.id_articolo_packaging,
                    },
                    {
                      parametro: "@seriale",
                      valore: jres.seriale,
                    },
                    {
                      parametro: "@pagine_slave",
                      valore: jres.nr,
                    },
                    {
                      parametro: "@cod_macchina",
                      valore: `${this.work_order.cod_macchina}`,
                    },
                    {
                      parametro: "@cod_articolo",
                      valore: `${this.work_order.cod_articolo}`,
                    },
                    {
                      parametro: "@quantita",
                      valore: `${this.work_order.quantita}`,
                    },
                    {
                      parametro: "@cod_articolo_packaging",
                      valore: `${this.prelievo.cod_packaging}`,
                    },
                    {
                      parametro: "@id_utente",
                      valore: localStorage.id,
                    },
                  ],
                },
              },
            };

            this.caricamento_dati = true;
            return this.$store
              .dispatch("api", request2)
              .then((res2) => {
                this.caricamento_dati = false;
                if (res2.status === 200) {
                  if (
                    "tipo_messaggio" in res2.data &&
                    "query_messaggio" in res2.data &&
                    res2.data.tipo_messaggio == 1
                  ) {
                    this.$refs.SnackbarQV.print(
                      "orange",
                      res2.data.query_messaggio
                    );
                  }

                  const response = res2.data.result;
                  const byteCharacters = atob(response);
                  const byteNumbers = new Array(byteCharacters.length);
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }
                  const byteArray = new Uint8Array(byteNumbers);
                  const blob = new Blob([byteArray], {
                    type: "application/pdf",
                  });
                  const blobUrl = URL.createObjectURL(blob);
                  this.items_risme_etichette = new Array();
                  this.items_risme_etichette.push({
                    cod_report: res.data.result[0].cod_report,
                    base64: blobUrl,
                    des: res.data.result[0].des,
                  });
                  this.dialog_risme_etichette = true;
                  return true;
                } else {
                  this.loading = false;
                  this.$refs.SnackbarQV.print(
                    "orange",
                    "Impossibile generare etichetta."
                  );
                  return false;
                }
              })
              .catch((err) => {
                this.caricamento_dati = false;
                console.error(err);
                if (
                  "tipo_messaggio" in err.response.data &&
                  "query_messaggio" in err.response.data &&
                  err.response.data.tipo_messaggio == 2
                ) {
                  this.$refs.SnackbarQV.print(
                    "error",
                    err.response.data.query_messaggio
                  );
                } else {
                  this.$refs.SnackbarQV.print(
                    "orange",
                    "Impossibile generare etichetta."
                  );
                }
                return false;
              });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>